import React from 'react';
import { fetchBackgroundJobs, fetchForm } from '../../../apis';
import { generateTable } from '../../table/Table';
import { defineFilter } from '../../../helpers';
var clientSide = defineFilter(true).equals('status', 'status').between('startedAt', 'minStartedAt', 'maxStartedAt').end();
var indexJobStatuses = ['Running', 'Paused'];

var dataSource = function dataSource(_ref) {
  var formSlug = _ref.formSlug;
  return {
    fn: function fn() {
      return formSlug ? fetchForm({
        datastore: true,
        formSlug: formSlug,
        include: 'backgroundJobs'
      }) : fetchBackgroundJobs();
    },
    clientSide: clientSide,
    params: function params() {
      return [];
    },
    transform: function transform(result) {
      return {
        data: formSlug ? result.form.backgroundJobs : result.backgroundJobs
      };
    }
  };
};

var filters = function filters() {
  return function () {
    return [{
      name: 'status',
      label: 'Status',
      type: 'select',
      options: indexJobStatuses.map(function (el) {
        return {
          value: el,
          label: el
        };
      })
    }, {
      name: 'minStartedAt',
      label: 'Start',
      type: 'date'
    }, {
      name: 'maxStartedAt',
      label: 'End',
      type: 'date'
    }];
  };
};

var columns = [{
  value: 'content',
  title: 'Content',
  components: {
    BodyCell: function BodyCell(props) {
      return /*#__PURE__*/React.createElement("td", null, JSON.stringify(props.value));
    }
  },
  sortable: false,
  filterable: false
}, {
  value: 'hung',
  title: 'Hung?'
}, {
  value: 'id',
  title: 'Job ID'
}, {
  value: 'message',
  title: 'Message'
}, {
  value: 'parent',
  title: 'Parent'
}, {
  value: 'parentType',
  title: 'Parent Type'
}, {
  value: 'progress',
  title: 'Progress',
  components: {
    BodyCell: function BodyCell(props) {
      return /*#__PURE__*/React.createElement("td", null, props.value && props.value.get('count') ? "".concat(props.value.get('count'), " submissions") : 'None');
    }
  }
}, {
  value: 'startedAt',
  title: 'Started At'
}, {
  value: 'startedBy',
  title: 'Started By'
}, {
  value: 'status',
  title: 'Status'
}, {
  value: 'type',
  title: 'Type'
}];
export var IndexJobTable = generateTable({
  tableOptions: ['formSlug'],
  dataSource: dataSource,
  columns: columns,
  filters: filters,
  sortable: false
});
IndexJobTable.displayName = 'IndexJobTable';